import variables from '../variables';

const text = {
  primary: variables.text.primary,
  textPrimary: variables.text.primary,
  textSecondary: variables.text.secondary,
  secondary: variables.text.secondary,
  primaryLight: variables.text.primaryLight,
  textPrimaryLight: variables.text.primaryLight,
  textSecondaryLight: variables.text.secondaryLight,
  secondaryLight: variables.text.secondaryLight,
};

export default text;
